import React from 'react';

import "./style.css"
import {Select, Input, Icon,message,Modal} from 'antd';
import EventSet from "./../../../assets/PubJs/hcPub"
import "./../../../assets/PubJs/Bcharts"
import {Hcurl} from "./../../../constants/index"//获取公共路径
import bq from "./../../../assets/images/BQ.svg"//图片
import editor from "./../../../assets/images/BJ.svg"//图片

import $ from "jquery"
const { TextArea } = Input;
const Option = Select.Option;

let _NodeTitle = null;
class NodeTitle extends React.Component {

    componentDidMount() {
        _NodeTitle = this;
    }

    render() {
        return (

            <div className="C_topTitle clear">
                <img style={{ width: "18px", position: "relative", top: "6.5px", marginRight:"6px" }} className="left" src={bq} alt="" />
                <span className="left">便签</span>
                <div className="right" style={{ marginLeft: "20px" }}>
                    <span rows={6} style={{ cursor: "pointer" }} onClick={() => _NodeModal.showModal()}> <img style={{ width: "16px", position: "relative", top: "10px", marginRight: "6px" }} className="left" src={editor} alt="" /></span>
                </div>
            </div>
        )
    }

}

let _NodeModal = null;
class NodeModal extends React.Component {
    state = {
        visible: false,
        value:""
    }
    showModal = (e) => {
        this.setState({
            visible: true,
            value:_App.state.txt2
        });

    };
    handleOk = (e) => {
       let _this=this
        if (this.state.value.length > 10000) {
            message.error("便签字符过长")
            return
        }
        let setData={
            "UserCode": EventSet.getUserInfo().CU_Code,
            "NoteContent": this.state.value
        };
        $.ajax({
            url: Hcurl+"/HomePage/SetUserNote",
            type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
            contentType: "application/json",
            data: JSON.stringify(setData),
            async: false,
            success: function (res) {
                if (res.split("|")[0]==="true"){
                    message.success(res.split("|")[1])
                    _App.getNodeTxt()
                    _this.setState({
                        visible: false,
                    });
                }else {
                    message.success(res.split("|")[1])
                }
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })

    };
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    };

    onchangeTxt(e) {
        if (e.target.value.length > 10000) {
            Modal.warning({
                okText:"确定",
                title: "提示",
                content: "便签字符过长"
            })
        }
        _NodeModal.setState({ value: e.target.value })
    }


    //组件完成后
    componentDidMount() {
        _NodeModal = this;
    }

    render() {
        return (
            <div>
                <Modal
                    title={"便签编辑"}
                    visible={this.state.visible}
                    width={660}
                    okText={"确定"}
                    cancelText={"取消"}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <TextArea rows={10} id="text" onChange={this.onchangeTxt} value={this.state.value} />
                </Modal>
            </div>
        );
    }
}

let _App = null;
class App extends React.Component {
    state = {
        txt1: "",
        txt2: "",
        listData:[]
    };

    componentWillMount() {
        _App = this;
    }

    getNodeTxt(){
        $.ajax({
            url: Hcurl + "/HomePage/GetUserNote?usercode="+EventSet.getUserInfo().CU_Code,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _App.setState({
                    txt1: ( res == null)?"":JSON.parse(res).UN_Content,
                    txt2:  res == null?"":JSON.parse(res).UN_Content2,
                }, () => {
                    $("#NodeText").html(_App.state.txt1)
                });
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({"pathname": "/err"})
                } else {
                    message.error(err)
                }
            }
        })
    }

    componentDidMount() {
        this.getNodeTxt()
    }


    render() {
        return (
            <div className="C_content">
                <NodeTitle/>
                <NodeModal/>
                <div className="C_content_son">
                    <div style={{padding:"16px",width:"100%",height:"100%",overflowY:"auto"}} id={"NodeText"}>

                    </div>
                </div>
            </div>
        )
    }
}

export default App


// WEBPACK FOOTER //
// ./src/components/Content/Home/Node.js